import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency';

import { theme } from '../constants/defaults';
import { getSizedImageUrl } from './image';

export function formatMoney(price) {
  return shopifyFormatMoney(price, theme.moneyFormat).replace('.00', '');
}

export function getProductImage(product, imageSize = '100x') {
  let image;
  let featuredImage;

  if (product.variants && product.variants.length > 0 && product.variants[0].image !== null) {
    featuredImage = product.variants[0].featured_image;
  } else if (product.image) {
    featuredImage = product.featured_image;
  } else {
    image = null;
  }

  if (image !== null) {
    image = {
      url: getSizedImageUrl(featuredImage.url, imageSize),
      alt: featuredImage.alt,
    };
  }

  return image;
}

export function isOnSale(product) {
  return (
    product.compare_at_price_min !== null &&
    parseInt(product.compare_at_price_min, 10) > parseInt(product.price_min, 10)
  );
}

export function isPriceVaries(product) {
  return product.price_max !== product.price_min;
}

export function isCompareVaries(product) {
  return product.compare_at_price_max !== product.compare_at_price_min;
}

export function normalizeProduct(product) {
  const productOrVariant =
    product.variants && product.variants.length > 0 ? product.variants[0] : product;

  return {
    url: productOrVariant.url,
    image: getProductImage(product),
    title: product.title,
    vendor: product.vendor || '',
    price: formatMoney(product.price_min),
    compareAtPrice: formatMoney(product.compare_at_price_min),
    available: product.available,
    isOnSale: isOnSale(product),
    isPriceVaries: isPriceVaries(product),
    isCompareVaries: isCompareVaries(product),
  };
}

export function normalizeProductItem(item) {
  return {
    key: item.key,
    url: item.url,
    image: getProductImage(item, '200x200_crop_center'),
    name: item.product_title,
    variation: item.variant_title,
    optionWithValue: item.options_with_values,
    vendor: item.vendor || '',
    properties: item.properties,
    quantity: item.quantity,
    price: formatMoney(item.price),
    linePrice: formatMoney(item.line_price),
    originalLinePrice: formatMoney(item.original_line_price),
    discounts: item.discounts,
    discountsApplied: item.line_price !== item.original_line_price,
  };
}
